import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslationService } from '@app/services/translation.service';
import { PopupComponent } from '@app/shared/component/popup/popup.component';
import { LabelsType } from '@app/shared/model/common.model';

@Component({
    selector: 'app-common',
    standalone: true,
    imports: [RouterOutlet, PopupComponent],
    templateUrl: './common.component.html',
    styleUrl: './common.component.scss',
})
export class CommonComponent {
    public commonLabels!: LabelsType<'commonLabels'>;

    constructor(
        private readonly router: Router,
        private readonly translationService: TranslationService
    ) {
        this.commonLabels = this.translationService.getLabels('commonLabels');
    }

    /**
     * Checks if the current route is the login page.
     * @return {boolean} True if the current route is the login page, false otherwise.
     */
    isLoginPage(): boolean {
        return this.router.url.includes('login');
    }
    public popup = {
        terms: false,
        privacy: false,
    };

    /**
     * Open the popup to Terms & Conditions page.
     */
    openTermsAndConditions() {
        this.popup.terms = true;
    }

    /**
     * Close the popup for Terms & Conditions or Privacy Policy.
     */
    closePopup() {
        this.popup.terms = false;
        this.popup.privacy = false;
    }

    /**
     * Open the popup to Privacy Policy page.
     */
    openPrivacyPolicy() {
        this.popup.privacy = true;
    }
}
